import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import TextInput from "../../inputs/TextInput";
import { TextField } from "@mui/material";

const RffTextField = React.memo(function RffTextField({
  name,
  label,
  required = false,
  placeholder = "Enter value",
  suppressGrid,
  size,
  onChange,
  inlineLabel = false,
  row = false,
  helperText,
  disabled,
  onBlur,
  testing,
  sx,
}) {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  return (
    <RffInputWrapper
      label={inlineLabel ? null : label}
      suppressGrid={suppressGrid}
      size={size}
      row={row}
      required={required}
      testing={testing}
      helperText={helperText}
    >
      <Field
        name={name}
        validate={validate}
        subscription={{ value: true, error: true, touched: true }}
        render={({ input, meta }) => {
          if (inlineLabel) {
            return (
              <TextField
                {...input}
                sx={sx}
                label={label}
                // onChange={(v) => {
                //   if (onChange) {
                //     onChange(v);
                //   }
                // }}
                onBlur={onBlur}
                disabled={disabled}
                placeholder={placeholder}
                error={meta.touched && !!meta.error}
                helperText={meta.touched && meta.error}
                // helperText={(meta.touched && meta.error) || helperText}
              />
            );
          }
          return (
            <TextInput
              {...input}
              sx={sx}
              // onChange={(v) => {
              //   if (onChange) {
              //     onChange(v);
              //   }
              // }}
              onBlur={onBlur}
              disabled={disabled}
              placeholder={placeholder}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error}
              // helperText={(meta.touched && meta.error) || helperText}
            />
          );
        }}
      />
    </RffInputWrapper>
  );
});

export default RffTextField;
